<div class="modal-body">
  <i class="icon-close" (click)="decline()"></i>
  <h5>{{name}}</h5>
  <div class="row" style="margin-top: 1.25rem;">
    <div class="col-lg-9 col-12">
      <div style="font-size: 14px;" [innerHTML]="description | safeHtml"></div>
    </div>
    <div class="col-lg-3 col-12">
      @if (image) {
        <img [src]="image">
      }
      <div class="date">
        <i class="icon-calendar"></i>
        <span class="ms-2">{{startDate| defaultDate}}</span>
      </div>
      @if (withTime) {
        <div class="date" style="margin-top: 0.75rem">
          <i class="icon-time"></i>
          <span class="ms-2">
            <span>{{startDate| date: 'shortTime'}} </span>
            @if (isOneDay) {
              <span>- {{ endDate | date: 'shortTime'}} </span>
            }
          </span>
        </div>
      }

    </div>
  </div>

</div>